export default __webpack_public_path__ + "static/media/ispo-img-2x.ec1d41ad.jpg";